module.exports = __webpack_public_path__ + "static/media/montserrat-regular-webfont.69eac499.ttf";